module.exports = __webpack_public_path__ + "static/media/noSearch.12266056.svg";